import styled from 'styled-components';

export const Container = styled.div`
  height: 200px;
  overflow-y: scroll;
`;
